(() => {
  try {
    // PRODUCT PAGE ONLY
    if (!document.body.className.includes("template-product")) return;

    // DESKTOP ONLY
    if (window.matchMedia("(max-width: 989px)").matches) return;

    const lb = document.createElement("div");
    lb.className = "ac-lightbox";
    lb.innerHTML = `
      <button class="ac-lightbox__close" aria-label="Close">×</button>
      <img class="ac-lightbox__img" alt="">
    `;
    document.body.appendChild(lb);

    const lbImg = lb.querySelector(".ac-lightbox__img");
    const closeBtn = lb.querySelector(".ac-lightbox__close");

    const open = (src, alt) => {
      lbImg.src = src;
      lbImg.alt = alt || "";
      lb.classList.add("is-open");
    };

    const close = () => {
      lb.classList.remove("is-open");
      lbImg.src = "";
    };

    closeBtn.addEventListener("click", close);

    // click outside image closes
    lb.addEventListener("click", (e) => {
      if (!e.target.closest(".ac-lightbox__img")) close();
    });

    // ESC closes
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });

    // open on image click
    document.body.addEventListener("click", (e) => {
      const img = e.target.closest(".product__media img, .product-image-wrapper img");
      if (!img) return;

      e.preventDefault();

      const src = img.currentSrc || img.src;
      if (!src) return;

      open(src, img.alt);
    });

  } catch (err) {
    console.warn("Lightbox disabled:", err);
  }
})();
